import React from "react";
import { useParams } from "react-router-dom";
import { FaClock, FaFolder } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_blog } from "../../../service/api/blog";
import { formatDate } from "../../../service/convert/date";
import HeaderTitle from "../../../components/ui/title";
import BlogComments from "../misc/BlogComments";

const ViewBlog = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { blog, blogLoading, blogError } = useAppSelector(
    ({ blog }) => blog,
  );

  React.useEffect(() => {
    if (id) {
      get_blog(dispatch, id);
    }
  }, [dispatch, id]);

  const date = blog?.created_at
    ? formatDate(new Date(blog.created_at))
    : "";

  return (
    <div className="w-full bg-white min-h-screen">
      <div className="max-w-7xl mx-auto pt-32 px-6 xl:px-0 pb-10 md:pb-20 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="mb-6">
            <HeaderTitle title={blog?.title || ""} />

            <div className="flex flex-wrap items-center text-gray-500 gap-4 mt-2">
              <span className="flex items-center">
                <FaClock className="mr-2 text-gray-400" />
                {date}
              </span>
              <span className="flex items-center">
                <FaFolder className="mr-2 text-gray-400" />
                {blog?.category?.name || "Uncategorized"}
              </span>
            </div>
          </div>

          {blog?.feature_image && (
            <div className="mb-8 overflow-hidden rounded-lg shadow-md">
              <img
                src={blog.feature_image}
                alt={blog?.title}
                className="w-full max-h-[32rem] object-cover rounded-lg"
              />
            </div>
          )}

          <div className="mb-10 prose prose-lg max-w-none">
            {blogLoading ? (
              <p className="text-gray-500">Loading blog...</p>
            ) : blogError ? (
              <p className="text-red-600">{blogError}</p>
            ) : (
              <div className="text-gray-800 whitespace-pre-wrap">
                {blog?.body || blog?.excerpt}
              </div>
            )}
          </div>

          {blog && <BlogComments key={blog.id} postId={blog.id} />}
        </div>

        <div className="lg:col-span-1">
          <div className="sticky top-32 bg-gray-50/20 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-bold mb-4 text-gray-900">
              Related Content
            </h3>
            <div className="space-y-4">
              {/* Content for sidebar can be added here */}
              <p className="text-gray-700">
                Additional blog information or related posts could be displayed
                here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBlog;
